import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import type { SalaryDistributionAnalyticalFeatureSettingsFormInterface } from '@zaoblako/shared/modules/document/dtos/salary-distribution/form/salary-distribution-analytical-feature-settings-form.interface';

import * as yup from 'yup';

/** Direction settings for salary distribution */
export type SalaryDistributionDirectionSettingsFormInterface = SalaryDistributionAnalyticalFeatureSettingsFormInterface<DirectionFindInterface>;

/** Direction settings for salary distribution - DTO schema */
export const SalaryDistributionDirectionSettingsFormDto = SerdeDtoClass.create<SalaryDistributionDirectionSettingsFormInterface>(
  DocumentDtoKeysEnum.SALARY_DISTRIBUTION_DIRECTION_SETTINGS_FORM_DTO,
  {
    distribute: {
      label: 'Распределить',
      serializer: yup.boolean(),
    },
    target: {
      label: 'БС',
      optional: true,
      checkers: [CatalogCheckersEnum.DIRECTION_ASSERT_EXISTS_BY_DTO],
      serializer: (): yup.Schema<any> => yup.object({
        id: yup
          .number()
          .positive(DtoMessageEnum.NOT_POSITIVE)
          .integer(DtoMessageEnum.NOT_INTEGER),
      }),
    },
  },
);
